export function mergeAndExcludeByKey<T>(
	array1: T[],
	array2: T[],
	key: keyof T,
): T[] {
	return array1
		.concat(
			array2.filter((item2) => (
				!array1.some((item1) => item1[key] === item2[key])
			)),
		);
}

export function mergeAndMergeByKey<T>(
	array1: T[],
	array2: T[],
	key: keyof T,
): T[] {
	const mergedArray = mergeAndExcludeByKey(
		array1,
		array2,
		key,
	);

	// eslint-disable-next-line no-restricted-syntax
	for (const item2 of array2) {
		const item1 = mergedArray.find((item) => item[key] === item2[key]);

		if (item1) {
			Object.assign(
				item1,
				item2,
			);
		}
	}

	return mergedArray;
}
